import React, { useState } from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { CTAButton } from '../components/CTAButton';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { CountdownTimer } from '../components/CountdownTimer';
import { Check, X, ChevronDown, ChevronUp, Star, Gift, BookOpen, DollarSign, Clock, ShoppingBag, Lock, Mail } from 'lucide-react';
// Image URLs provided
const IMAGES = {
  bonus1: 'https://cdn.magicpatterns.com/uploads/vACfBXZWwNbh87Vy3Kz6qA/BONUS_1.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/pzNdRe1LFeKERMrdgcK4tN/BONUS_2.png',
  mockupGroup: 'https://cdn.magicpatterns.com/uploads/eWHUuKXwjQGc7pV58PkPcG/MOCKUP_GRUPAL_1.png',
  mainMockup: 'https://cdn.magicpatterns.com/uploads/eWHUuKXwjQGc7pV58PkPcG/MOCKUP_GRUPAL_1.png',
  client1: 'https://cdn.magicpatterns.com/uploads/26CWsr7qWU3rSRVV8Vka1U/1.png',
  client2: 'https://cdn.magicpatterns.com/uploads/s8gyxa6HyKC6M2fczJrAYe/2.png',
  client3: 'https://cdn.magicpatterns.com/uploads/rp1fc812dfNrTh9B6pBYTd/3.png',
  client4: 'https://cdn.magicpatterns.com/uploads/89GoR5MoY9BjwRGcFjHWsR/4.png',
  // Testimonial avatars
  avatarPablo: 'https://cdn.magicpatterns.com/uploads/qzg34ztNtorQc4Y3nvu2eZ/20250822_1545_Authentic_Accidental_Selfie_simple_compose_01k39hj6crebftjzwpk85srtrs.png',
  avatarLucas: 'https://cdn.magicpatterns.com/uploads/cHtZNdTCTetWutESgYWk7Q/20250822_1549_Argentinian_City_Selfie_simple_compose_01k39hrhmafkfavf4x26w4s6s5.png',
  avatarFlorencia: 'https://cdn.magicpatterns.com/uploads/a6iCVxvzpyN5fRs5NpHbF2/20250814_2238_Casual_Selfie_Charm_simple_compose_01k2np06w7evavb22ga1pr14k4.png',
  avatarAndrea: 'https://cdn.magicpatterns.com/uploads/6o3eMMkjKodVF47NKvVSsk/1.png'
};
const CHECKOUT_URL = 'https://checkout.ultrapack.digital/cart/47886149222555:1';
export function SushiDulceLanding() {
  return <div className="min-h-screen font-sans text-chocolate bg-warmWhite" data-id="element-24">
      <AnnouncementBar data-id="element-25" />

      {/* HERO SECTION - NOW WITH NAVY BACKGROUND */}
      <header className="bg-navy pt-12 pb-20 px-4 md:px-8 text-center relative overflow-hidden" data-id="element-26">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-27">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight text-warmWhite" data-id="element-28">
            Tus primeros <span className="text-orange" data-id="element-29">$400.000</span> en menos
            de <span className="text-orange" data-id="element-30">7 días</span> vendiendo sushi dulce
            con recetas simples{' '}
            <span className="text-orange" data-id="element-31">desde tu casa</span>.
          </h1>

          <div className="my-10 transform hover:scale-105 transition-transform duration-500" data-id="element-32">
            <img src={IMAGES.mainMockup} alt="Mockup Principal Sushi Dulce" className="w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-33" />
          </div>

          <p className="text-xl md:text-2xl font-medium mb-10 max-w-2xl mx-auto text-warmWhite/90" data-id="element-34">
            El método paso a paso para crear, presentar y vender sushi dulce en
            Argentina, sin publicidad paga ni seguidores.
          </p>
        </div>

        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-35">
          <div className="absolute -top-20 -left-20 w-64 h-64 bg-orange rounded-full blur-3xl" data-id="element-36"></div>
          <div className="absolute top-40 -right-20 w-72 h-72 bg-mint rounded-full blur-3xl" data-id="element-37"></div>
        </div>
      </header>

      {/* CLIENT IMAGES SECTION - VERTICAL STACK */}
      <section className="py-20 px-4 md:px-8 bg-cream" data-id="element-38">
        <div className="max-w-3xl mx-auto" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-chocolate" data-id="element-40">
            Imágenes reales de nuestros clientes
          </h2>
          <div className="space-y-6" data-id="element-41">
            {[IMAGES.client1, IMAGES.client2, IMAGES.client3, IMAGES.client4].map((img, i) => <div key={i} className="aspect-square overflow-hidden rounded-xl shadow-lg" data-id="element-42">
                <img src={img} alt={`Cliente ${i + 1}`} className="w-full h-full object-cover" data-id="element-43" />
              </div>)}
          </div>
        </div>
      </section>

      {/* PROBLEM SECTION - NOW WARMWHITE */}
      <section className="py-20 px-4 md:px-8 bg-warmWhite" data-id="element-44">
        <div className="max-w-3xl mx-auto" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-46">
            El problema no es querer ganar más.
            <br data-id="element-47" />
            <span className="text-orange" data-id="element-48">
              El problema es no saber por dónde empezar.
            </span>
          </h2>

          <p className="text-lg mb-8 text-center" data-id="element-49">
            Hoy, muchas personas quieren generar un ingreso extra… pero se
            encuentran siempre con lo mismo:
          </p>

          <div className="space-y-4 mb-12 bg-white p-8 rounded-2xl shadow-sm border border-chocolate/5" data-id="element-50">
            {['Ideas que no se venden', 'Negocios que requieren mucha inversión', 'Cursos que enseñan cosas, pero no cómo ganar dinero', 'Miedo a perder plata o tiempo', 'Falta de claridad para empezar'].map((item, i) => <div key={i} className="flex items-start" data-id="element-51">
                <X className="w-6 h-6 text-red-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-52" />
                <span className="text-lg" data-id="element-53">{item}</span>
              </div>)}
          </div>

          <div className="bg-chocolate/5 p-8 rounded-2xl border-l-4 border-chocolate" data-id="element-54">
            <h3 className="text-xl font-bold mb-4" data-id="element-55">Y mientras tanto:</h3>
            <ul className="space-y-3" data-id="element-56">
              <li className="flex items-center" data-id="element-57">
                <div className="w-2 h-2 bg-chocolate rounded-full mr-3" data-id="element-58"></div>
                El sueldo no alcanza
              </li>
              <li className="flex items-center" data-id="element-59">
                <div className="w-2 h-2 bg-chocolate rounded-full mr-3" data-id="element-60"></div>
                Los gastos siguen subiendo
              </li>
              <li className="flex items-center" data-id="element-61">
                <div className="w-2 h-2 bg-chocolate rounded-full mr-3" data-id="element-62"></div>Y
                la sensación de "podría estar haciendo algo más" no se va
              </li>
            </ul>
            <p className="mt-6 font-semibold text-lg italic" data-id="element-63">
              No falta ganas. No falta esfuerzo. Falta una oportunidad clara,
              simple y posible.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION - NOW NAVY */}
      <section className="py-20 px-4 md:px-8 bg-navy text-warmWhite" data-id="element-64">
        <div className="max-w-4xl mx-auto" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-66">
            La solución es simple:{' '}
            <span className="text-orange" data-id="element-67">usar algo que ya se vende.</span>
          </h2>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-68">
            <div data-id="element-69">
              <p className="text-lg mb-6" data-id="element-70">
                En lugar de buscar ideas complicadas o negocios imposibles, la
                clave está en aprovechar una demanda que ya existe.
              </p>
              <p className="text-xl font-bold mb-6" data-id="element-71">Hoy, el Sushi Dulce:</p>
              <ul className="space-y-4" data-id="element-72">
                {['Se vende por curiosidad y antojo', 'Llama la atención en redes sociales', 'Tiene bajo costo de preparación', 'Se puede hacer por pedidos', 'Poca gente lo está haciendo'].map((item, i) => <li key={i} className="flex items-center bg-warmWhite/10 p-3 rounded-lg" data-id="element-73">
                    <Check className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" data-id="element-74" />
                    <span data-id="element-75">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-warmWhite text-chocolate p-8 rounded-2xl shadow-lg transform rotate-1" data-id="element-76">
              <p className="text-lg leading-relaxed" data-id="element-77">
                Por eso creamos un método que no se enfoca en "aprender
                recetas", sino en{' '}
                <span className="font-bold bg-orange/20 px-1" data-id="element-78">
                  transformar esta tendencia en una fuente real de ingresos
                  extra.
                </span>
              </p>
              <p className="mt-6 text-lg leading-relaxed" data-id="element-79">
                Un sistema pensado para empezar desde casa, con pasos claros y
                sin vueltas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* METHOD SECTION - NOW CREAM */}
      <section className="py-20 px-4 md:px-8 bg-cream" data-id="element-80">
        <div className="max-w-5xl mx-auto" data-id="element-81">
          <div className="text-center mb-16" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-83">
              Este método no se basa en teoría ni promesas vacías.
            </h2>
            <p className="text-xl text-chocolate/80" data-id="element-84">
              Está diseñado para que sepas qué hacer, cómo hacerlo y para qué.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-85">
            {/* WHAT YOU RECEIVE */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-t-8 border-orange" data-id="element-86">
              <div className="bg-orange/10 p-6" data-id="element-87">
                <h3 className="text-2xl font-bold flex items-center" data-id="element-88">
                  <span className="bg-orange text-white w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-89">
                    1
                  </span>
                  QUÉ VAS A RECIBIR
                </h3>
                <p className="mt-2 text-sm opacity-80" data-id="element-90">
                  Al acceder al pack, vas a recibir:
                </p>
              </div>
              <div className="p-8" data-id="element-91">
                <ul className="space-y-4" data-id="element-92">
                  {['Un sistema paso a paso para crear y vender sushi dulce, desde cero y sin complicarte', 'Recetas claras y prácticas de sushi dulce con arroz, crepé, bizcocho y masa de galleta', 'Métodos simples para armar rollos, mini piezas y bandejas listas para vender', 'Una guía ordenada para empezar desde casa, incluso si nunca vendiste nada', 'Contenido pensado para que avances sin improvisar ni perder tiempo'].map((item, i) => <li key={i} className="flex items-start" data-id="element-93">
                      <div className="bg-orange/20 p-1 rounded mt-1 mr-3" data-id="element-94">
                        <Gift className="w-4 h-4 text-orange" data-id="element-95" />
                      </div>
                      <span data-id="element-96">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            {/* WHAT YOU ACHIEVE */}
            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border-t-8 border-mint" data-id="element-97">
              <div className="bg-mint/20 p-6" data-id="element-98">
                <h3 className="text-2xl font-bold flex items-center" data-id="element-99">
                  <span className="bg-mint text-chocolate w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm" data-id="element-100">
                    2
                  </span>
                  QUÉ VAS A LOGRAR
                </h3>
                <p className="mt-2 text-sm opacity-80" data-id="element-101">
                  Con este sistema vas a poder:
                </p>
              </div>
              <div className="p-8" data-id="element-102">
                <ul className="space-y-4" data-id="element-103">
                  {['Generar una fuente de ingresos extra desde tu casa', 'Empezar sin experiencia previa y sin grandes inversiones', 'Convertir preparaciones simples en productos que se venden', 'Aprovechar una demanda real y en crecimiento en Argentina', 'Tener claridad, estructura y confianza para avanzar paso a paso'].map((item, i) => <li key={i} className="flex items-start" data-id="element-104">
                      <div className="bg-mint/30 p-1 rounded mt-1 mr-3" data-id="element-105">
                        <Star className="w-4 h-4 text-chocolate" data-id="element-106" />
                      </div>
                      <span data-id="element-107">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION - NOW NAVY */}
      <section className="py-20 px-4 md:px-8 bg-navy text-warmWhite" data-id="element-108">
        <div className="max-w-5xl mx-auto" data-id="element-109">
          <div className="text-center mb-16" data-id="element-110">
            <span className="bg-orange text-white px-4 py-1 rounded-full text-sm font-bold tracking-wider uppercase mb-4 inline-block" data-id="element-111">
              Regalos Exclusivos
            </span>
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-112">
              ADEMÁS, RECIBÍS ESTOS BONOS PARA ACELERAR TUS RESULTADOS
            </h2>
          </div>

          {/* BONUS 1 */}
          <div className="bg-warmWhite text-chocolate rounded-3xl p-8 md:p-12 mb-12 shadow-2xl" data-id="element-113">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-114">
              <div className="order-2 md:order-1" data-id="element-115">
                <div className="inline-block bg-orange text-white px-3 py-1 rounded text-sm font-bold mb-4" data-id="element-116">
                  BONO #1
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-117">
                  Presentación & Packaging que Vende Sushi Dulce
                </h3>

                <div className="mb-6" data-id="element-118">
                  <h4 className="font-bold text-lg mb-2 flex items-center" data-id="element-119">
                    <BookOpen className="w-5 h-5 mr-2 text-orange" data-id="element-120" /> Qué es:
                  </h4>
                  <p className="text-chocolate/80" data-id="element-121">
                    Un ebook práctico donde aprendés a presentar tu sushi dulce
                    de forma profesional, atractiva y lista para vender, incluso
                    si empezás desde casa.
                  </p>
                </div>

                <div data-id="element-122">
                  <h4 className="font-bold text-lg mb-2 flex items-center" data-id="element-123">
                    <Star className="w-5 h-5 mr-2 text-orange" data-id="element-124" /> Para qué te
                    sirve:
                  </h4>
                  <ul className="space-y-2 text-chocolate/80" data-id="element-125">
                    <li className="flex items-start" data-id="element-126">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-127" />{' '}
                      Hacer que tu producto se vea más premium sin gastar de más
                    </li>
                    <li className="flex items-start" data-id="element-128">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-129" />{' '}
                      Armar bandejas y presentaciones que aumenten el valor
                      percibido
                    </li>
                    <li className="flex items-start" data-id="element-130">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-131" />{' '}
                      Evitar errores comunes que hacen que un buen producto se
                      vea "amateur"
                    </li>
                    <li className="flex items-start" data-id="element-132">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-133" />{' '}
                      Preparar el sushi dulce para fotos, redes sociales y
                      entregas
                    </li>
                  </ul>
                </div>

                <div className="mt-6 p-4 bg-cream rounded-lg border border-orange/20" data-id="element-134">
                  <p className="font-bold text-orange" data-id="element-135">
                    👉 Ideal para destacar frente a otros y cobrar mejor desde
                    el inicio.
                  </p>
                </div>
              </div>
              <div className="order-1 md:order-2 flex justify-center" data-id="element-136">
                <img src={IMAGES.bonus1} alt="Bono 1 Packaging" className="w-full max-w-sm drop-shadow-2xl transform hover:scale-105 transition-duration-300" data-id="element-137" />
              </div>
            </div>
          </div>

          {/* BONUS 2 */}
          <div className="bg-cream text-chocolate rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-138">
            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-139">
              <div className="flex justify-center" data-id="element-140">
                <img src={IMAGES.bonus2} alt="Bono 2 Redes Sociales" className="w-full max-w-sm drop-shadow-2xl transform hover:scale-105 transition-duration-300" data-id="element-141" />
              </div>
              <div data-id="element-142">
                <div className="inline-block bg-orange text-white px-3 py-1 rounded text-sm font-bold mb-4" data-id="element-143">
                  BONO #2
                </div>
                <h3 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-144">
                  Cómo Vender Sushi Dulce en Redes Sociales (Sin Ser Influencer)
                </h3>

                <div className="mb-6" data-id="element-145">
                  <h4 className="font-bold text-lg mb-2 flex items-center" data-id="element-146">
                    <BookOpen className="w-5 h-5 mr-2 text-orange" data-id="element-147" /> Qué es:
                  </h4>
                  <p className="text-chocolate/80" data-id="element-148">
                    Un ebook claro y directo que te muestra cómo conseguir
                    pedidos reales usando Instagram y WhatsApp, sin necesidad de
                    anuncios pagos ni miles de seguidores.
                  </p>
                </div>

                <div data-id="element-149">
                  <h4 className="font-bold text-lg mb-2 flex items-center" data-id="element-150">
                    <Star className="w-5 h-5 mr-2 text-orange" data-id="element-151" /> Para qué te
                    sirve:
                  </h4>
                  <ul className="space-y-2 text-chocolate/80" data-id="element-152">
                    <li className="flex items-start" data-id="element-153">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-154" />{' '}
                      Saber qué mostrar y cómo mostrarlo para generar interés
                    </li>
                    <li className="flex items-start" data-id="element-155">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-156" />{' '}
                      Aprender a responder mensajes y cerrar ventas sin
                      incomodidad
                    </li>
                    <li className="flex items-start" data-id="element-157">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-158" />{' '}
                      Ofrecer combos y bandejas de forma simple
                    </li>
                    <li className="flex items-start" data-id="element-159">
                      <Check className="w-4 h-4 mr-2 mt-1 text-green-600" data-id="element-160" />{' '}
                      Organizar pedidos para eventos sin estrés ni confusión
                    </li>
                  </ul>
                </div>

                <div className="mt-6 p-4 bg-white rounded-lg border border-orange/20" data-id="element-161">
                  <p className="font-bold text-orange" data-id="element-162">
                    👉 Menos dudas, más pedidos y un camino claro para empezar a
                    vender.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SUMMARY - NOW WARMWHITE */}
      <section className="py-20 px-4 md:px-8 bg-warmWhite" data-id="element-163">
        <div className="max-w-4xl mx-auto" data-id="element-164">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-165">
            🎁 Todo lo que te llevás al acceder hoy
          </h2>

          <div className="mb-12 flex justify-center" data-id="element-166">
            <img src={IMAGES.mockupGroup} alt="Pack Completo Sushi Dulce" className="w-full max-w-3xl drop-shadow-2xl" data-id="element-167" />
          </div>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-chocolate/10 mb-12" data-id="element-168">
            <ul className="space-y-4 mb-10" data-id="element-169">
              {['Sistema completo para aprender sushi dulce y convertirlo en una fuente de ingresos', 'Método paso a paso, pensado para empezar desde casa, incluso sin experiencia previa', 'Recetas claras y prácticas de sushi dulce (arroz, crepé, bizcocho y masa de galleta), listas para vender por pedidos', 'Guía de presentación, combos y precios para cobrar con seguridad y profesionalismo', 'Acceso inmediato a todo el contenido digital', 'Actualizaciones incluidas, sin costo adicional', 'BONO #1: Presentación & Packaging que Vende Sushi Dulce', 'BONO #2: Cómo Vender Sushi Dulce en Redes Sociales (Sin Ser Influencer)'].map((item, i) => <li key={i} className="flex items-start text-lg" data-id="element-170">
                  <CheckCircleIcon className="w-6 h-6 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-171" />
                  <span className={item.includes('BONO') ? 'font-bold text-orange' : ''} data-id="element-172">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center border-t border-gray-200 pt-10" data-id="element-173">
              <div className="flex flex-col items-center justify-center mb-8" data-id="element-174">
                <span className="text-gray-400 text-2xl line-through mb-2 decoration-red-500 decoration-2" data-id="element-175">
                  $50.000
                </span>
                <span className="text-6xl font-extrabold text-chocolate" data-id="element-176">
                  $19.990
                </span>
              </div>

              <CTAButton href={CHECKOUT_URL} fullWidth className="max-w-md mx-auto text-xl py-5" data-id="element-177">
                QUIERO ACCEDER AHORA
              </CTAButton>

              <div className="mt-6 flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500" data-id="element-178">
                <span className="flex items-center" data-id="element-179">
                  <Lock className="w-3 h-3 mr-1" data-id="element-180" /> Pago asegurado por Mercado
                  Pago
                </span>
                <span className="flex items-center" data-id="element-181">
                  <Mail className="w-3 h-3 mr-1" data-id="element-182" /> Acceso Inmediato
                </span>
                <CountdownTimer minutes={17} showIcon={true} className="text-orange" data-id="element-183" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS - NOW NAVY WITH AVATARS */}
      <section className="py-20 px-4 md:px-8 bg-navy text-warmWhite" data-id="element-184">
        <div className="max-w-6xl mx-auto" data-id="element-185">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-186">
            Personas comunes que ya dieron el primer paso
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-187">
            {[{
            text: 'Es ideal si querés un ingreso extra sin complicarte ni invertir de más. Muy claro y práctico.',
            author: 'Pablo D.',
            avatar: IMAGES.avatarPablo
          }, {
            text: 'Me gustó porque no te marean. Es directo, simple y pensado para vender, no solo para aprender recetas.',
            author: 'Lucas R.',
            avatar: IMAGES.avatarLucas
          }, {
            text: 'Nunca había hecho nada para vender y acá entendí por dónde empezar. Eso ya vale un montón.',
            author: 'Florencia M.',
            avatar: IMAGES.avatarFlorencia
          }, {
            text: 'Lo que más me sirvió fue tener todo ordenado: qué hacer, cómo venderlo y cómo cobrar. Te ahorra mucha cabeza.',
            author: 'Andrea S.',
            avatar: IMAGES.avatarAndrea
          }].map((testimonial, i) => <div key={i} className="bg-warmWhite text-chocolate p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow" data-id="element-188">
                <div className="flex items-center mb-4" data-id="element-189">
                  <img src={testimonial.avatar} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover mr-3 border-2 border-orange" data-id="element-190" />
                  <div data-id="element-191">
                    <p className="font-bold text-chocolate" data-id="element-192">
                      {testimonial.author}
                    </p>
                    <div className="flex text-orange" data-id="element-193">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-current" data-id="element-194" />)}
                    </div>
                  </div>
                </div>
                <p className="text-chocolate/80 italic text-sm" data-id="element-195">
                  "{testimonial.text}"
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE - NOW CREAM */}
      <section className="py-20 px-4 md:px-8 bg-cream" data-id="element-196">
        <div className="max-w-3xl mx-auto text-center" data-id="element-197">
          <div className="w-24 h-24 bg-mint/20 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-198">
            <CheckCircleIcon className="w-12 h-12 text-mint" data-id="element-199" />
          </div>
          <h2 className="text-3xl font-bold mb-6" data-id="element-200">
            Probalo sin riesgo durante 7 días
          </h2>
          <p className="text-lg mb-6" data-id="element-201">
            Queremos que tomes la decisión con tranquilidad. Por eso, tenés 7
            días de garantía para revisar el contenido y ver si este método es
            para vos.
          </p>
          <p className="text-lg font-medium mb-8" data-id="element-202">
            Si sentís que no cumple con tus expectativas, podés solicitar el
            reembolso y listo.
            <br data-id="element-203" />
            <span className="text-chocolate/70 text-base" data-id="element-204">
              Sin explicaciones incómodas. Sin vueltas.
            </span>
          </p>
        </div>
      </section>

      {/* FAQ - NOW WARMWHITE */}
      <section className="py-20 px-4 md:px-8 bg-warmWhite" data-id="element-205">
        <div className="max-w-3xl mx-auto" data-id="element-206">
          <h2 className="text-3xl font-bold text-center mb-12 flex items-center justify-center" data-id="element-207">
            <span className="bg-chocolate text-white w-10 h-10 rounded-full flex items-center justify-center mr-3 text-xl" data-id="element-208">
              ?
            </span>
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4" data-id="element-209">
            {[{
            q: '¿Necesito experiencia previa en repostería?',
            a: 'No. El método está pensado para personas que empiezan desde cero y buscan una forma simple de generar ingresos extra.'
          }, {
            q: '¿Necesito maquinaria o herramientas especiales?',
            a: 'No. Todo se puede hacer con elementos básicos y accesibles.'
          }, {
            q: '¿Cuánto tiempo lleva empezar?',
            a: 'El contenido está pensado para que puedas empezar rápido, sin procesos largos ni complicados.'
          }, {
            q: '¿Esto es solo para vender o también sirve para consumo personal?',
            a: 'Sirve para ambas cosas, pero el enfoque principal es generar ingresos extra.'
          }, {
            q: '¿Cómo accedo al contenido?',
            a: 'El acceso es 100% digital e inmediato. Vas a recibir el material para verlo desde cualquier dispositivo.'
          }, {
            q: '¿Funciona si tengo poco tiempo?',
            a: 'Sí. Está diseñado para personas con rutinas ocupadas que buscan algo práctico y manejable.'
          }, {
            q: '¿Tiene garantía?',
            a: 'Sí. Contás con 7 días de garantía para revisar el contenido y decidir con tranquilidad.'
          }].map((faq, i) => <FaqItem key={i} question={faq.q} answer={faq.a} data-id="element-210" />)}
          </div>

          <div className="mt-16 text-center" data-id="element-211">
            <CTAButton href={CHECKOUT_URL} className="px-12" data-id="element-212">
              QUIERO ACCEDER AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      <footer className="bg-navy text-warmWhite/60 py-12 text-center text-sm" data-id="element-213">
        <div className="max-w-4xl mx-auto px-4" data-id="element-214">
          <p className="mb-4" data-id="element-215">
            © {new Date().getFullYear()} Sushi Dulce. Todos los derechos
            reservados.
          </p>
          <p data-id="element-216">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-217" />
    </div>;
}
function CheckCircleIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-218">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-219"></path>
      <polyline points="22 4 12 14.01 9 11.01" data-id="element-220"></polyline>
    </svg>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-xl shadow-sm border border-chocolate/5 overflow-hidden" data-id="element-221">
      <button className="w-full px-6 py-4 text-left font-bold flex justify-between items-center hover:bg-gray-50 transition-colors" onClick={() => setIsOpen(!isOpen)} data-id="element-222">
        <span data-id="element-223">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-orange" data-id="element-224" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-225" />}
      </button>
      {isOpen && <div className="px-6 pb-6 pt-2 text-chocolate/80 border-t border-gray-100 animate-in slide-in-from-top-2 fade-in duration-200" data-id="element-226">
          {answer}
        </div>}
    </div>;
}